import { getItemColumnValues } from './gallery-sample';

function isPlaceholderItemId(itemId?: string | number | null): boolean {
  return itemId == null || itemId === '' || itemId === 0 || itemId === '0';
}

export function subitemsHaveColumnValues(
  subitems:
    | Array<{
        column_values?: Array<{
          text?: string | null;
          display_value?: string | null;
          displayValue?: string | null;
        }> | null;
        columnValues?: Array<{
          text?: string | null;
          display_value?: string | null;
          displayValue?: string | null;
        }> | null;
      }>
    | null
    | undefined,
): boolean {
  return (subitems ?? []).some(item =>
    getItemColumnValues(item).some(column => {
      const text =
        column?.text ?? column?.display_value ?? column?.displayValue ?? '';
      return String(text).trim().length > 0;
    }),
  );
}

export async function resolveSubitemSample<T>(args: {
  requestedItemId: string;
  fallbackSubitemBoardId?: string | number | null;
  fetchSubitems: (itemId: string) => Promise<T[]>;
  fetchParentItemId: (
    fallbackSubitemBoardId: string | number,
  ) => Promise<string | null>;
}): Promise<{ itemId: string; subitems: T[] }> {
  if (!isPlaceholderItemId(args.requestedItemId)) {
    const subitems = await args.fetchSubitems(args.requestedItemId);
    if (
      subitemsHaveColumnValues(subitems) ||
      !args.fallbackSubitemBoardId
    ) {
      return { itemId: args.requestedItemId, subitems };
    }
  } else if (!args.fallbackSubitemBoardId) {
    return { itemId: args.requestedItemId, subitems: [] };
  }

  const parentItemId = await args.fetchParentItemId(args.fallbackSubitemBoardId);
  if (!parentItemId) {
    return { itemId: args.requestedItemId, subitems: [] };
  }

  const fallbackSubitems = await args.fetchSubitems(parentItemId);
  return { itemId: String(parentItemId), subitems: fallbackSubitems };
}
